export const environment = {
	production: true,
	apiUrl: '/api',
		sentryDSN: "https://426e17e5eb5f4baf9141648cba192b2a@o890051.ingest.sentry.io/5908863",

	socketUrl: null,
	CLOUD_URL: null,
};
